import { Component } from "react"
import { find, get } from "lodash"
import PropTypes from "prop-types"
import { Button, DialogActions, DialogContent } from "@mui/material"
import ForecastSelector from "components/forecast-selector"
import "./style.scss"

class EditForecast extends Component {
  static propTypes = {
    close: PropTypes.func,
    applyForecast: PropTypes.func.isRequired,
    horizon: PropTypes.number,
    forecasts: PropTypes.array.isRequired,
    selectedForecast: PropTypes.object,
    isOpPro: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    horizon: 252,
  }

  constructor(props, ...args) {
    super(props, ...args)
    const defaultState = {
      horizon: this.props.horizon,
      selectedForecast: this.props.selectedForecast,
    }

    this.state = {
      submitDisabled: true,
      ...defaultState,
    }
  }

  applyForecast = () => {
    const { applyForecast, close } = this.props
    const { selectedForecast, horizon } = this.state
    applyForecast({ forecast: selectedForecast, horizon })
    close()
  }

  setForecast = forecast => {
    const { forecasts } = this.props
    const forecastData = forecast ? find(forecasts, { id: forecast }) : null
    this.setState({ selectedForecast: forecastData, submitDisabled: this.computeDisabledButton(forecastData, this.state.horizon) })
  }

  setHorizon = horizon => {
    this.setState({ horizon, submitDisabled: this.computeDisabledButton(this.state.selectedForecast, horizon) })
  }

  computeDisabledButton = (forecast, horizon) => {
    const initialForecastId = get(this.props, "selectedForecast.id", null)
    const selectedForecastId = get(forecast, "id", null)
    return (selectedForecastId === initialForecastId) && (this.props.horizon === horizon)
  }

  render() {
    const { submitDisabled, selectedForecast, horizon } = this.state
    const { close, forecasts, isOpPro } = this.props

    return <>
      <DialogContent className="edit-forecast">
        <ForecastSelector
          forecasts={forecasts}
          selectedForecast={selectedForecast}
          setForecast={this.setForecast}
          setHorizon={this.setHorizon}
          horizon={horizon}
          isOpPro={isOpPro}
        />
      </DialogContent>
      <DialogActions className="edit-forecast-actions">
        <Button color="secondary" onClick={close}>Cancel</Button>
        <Button color="primary" disabled={submitDisabled} onClick={this.applyForecast}>Apply</Button>
      </DialogActions>
    </>
  }
}

export default EditForecast
